import { ref, computed, provide, watch, inject} from 'vue';
import { requestIpa } from '../utils/client';
import { useDocumentEvent } from '../utils/dom';
import { parsePlainWords } from '../utils/wordParsing';

export function setupReadonly({
  text = ref(''),
  ipaText = ref(''),
  playing = ref(false),
  started = ref(false),
  ttsMode = ref(false),
  ttsTexts = ref([]),
  ttsIndex = ref(0),
  ttsLocale = ref(0),
  voice = ref(null),
  textArray = ref([]),
  displayMode = ref('ipa'),
  speed = ref(null),
  sl = ref(''),
  firstTimeDisplaying = ref(true),
  ttsManagerService = ref(null),
}){
  const plainWords = computed(()=>{
    return (text.value) ? parsePlainWords(text.value, ttsMode.value) : []
  })

  const plainSymbols = computed(()=>{
    return (ipaText.value) ? parsePlainWords(ipaText.value, ttsMode.value) : []
  })


  const isPlaying = computed(()=>{
    return started.value || playing.value;
  })

  const currentIpaChunk = computed(()=>{
    if (!isPlaying.value)
      return ipaText.value
    return plainSymbols.value[ttsIndex.value]
  })

  const currentInputChunk = computed(()=>{
    if (!isPlaying.value)
      return text.value
    return plainWords.value[ttsIndex.value]
  })

  const displayText = computed(()=>{
    return displayMode.value === 'ipa'
      ? currentIpaChunk.value
      : currentInputChunk.value
  })

  const subtext = computed(()=>{
    if (!started.value) return "";
    return displayMode.value !== 'ipa'
      ? currentIpaChunk.value
      : currentInputChunk.value
  })

  watch(plainWords,(newVal)=>{
    textArray.value = newVal;
  })

  const handleDisplayMode = (newVal)=>{
    displayMode.value = newVal
  }

  const handleSpeedChange = (value)=>{
    speed.value = value
  }
  
  provide('plainWords', plainWords);

  const getIpa = ()=>{
    requestIpa(text.value, ttsLocale.value || sl.value, {
      mode: ttsMode.value
    })
    .then(data => ipaText.value = data)
    .catch(err => console.error(err))  
  }
  watch(ttsMode, getIpa);

  const handlePlayPause = ()=>{
    ttsManagerService.value.pauseResume();
  }
  //const handlePlayPause = inject('handlePlayPause');

  const handleVoiceChanged = (newVoice)=>{
    voice.value = newVoice;
  }

  const handleTTSMode = (newTTSModeValue)=>{
    ttsMode.value = newTTSModeValue;
  }

  const handleKeypress = (event)=>{
    var key = event.key || event.keyCode;
    if (key === 'Escape' || key === 27){ 
      firstTimeDisplaying.value = false;
    } 
  }

  useDocumentEvent('keydown', handleKeypress);

  ttsManagerService.value.addEventListener('ended', ()=>{
    firstTimeDisplaying.value = false;
  })

  watch(plainWords, ()=>{
    ttsTexts.value = plainWords.value;
  })

  getIpa();


  return {
    handlePlayPause,
    isPlaying,
    handleVoiceChanged,
    handleTTSMode,
    handleDisplayMode,
    handleSpeedChange,
    subtext,
    displayText,
    displayMode,
    plainWords,
    currentInputChunk,
    currentIpaChunk,
    firstTimeDisplaying,
  }
}
